import React, { FC, ReactNode } from 'react'
import { Wrapper } from './LotViewToggle.style'

interface Props {
    children: ReactNode
    cardShown: boolean
    onClick: () => void
}

const LotViewToggle: FC<Props> = ({ children, cardShown, onClick }) => {
    return (
        <Wrapper $cardShown={cardShown} onClick={onClick}>
            {children}
        </Wrapper>
    )
}

export default LotViewToggle
